import { render, staticRenderFns } from "./SizeOptions.vue?vue&type=template&id=55f72dae&scoped=true&"
import script from "./SizeOptions.vue?vue&type=script&lang=ts&"
export * from "./SizeOptions.vue?vue&type=script&lang=ts&"
import style0 from "./SizeOptions.vue?vue&type=style&index=0&id=55f72dae&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f72dae",
  null
  
)

export default component.exports